import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import './RoleContextBadge.css';

const ROLE_LABELS: Record<string, string> = {
  ADMIN: 'Admin',
  TEACHER: 'Maestro',
  PARENT: 'Padre',
  STUDENT: 'Alumno',
};

/**
 * Displays the authenticated user's role as a coloured pill in the header.
 * When a parent has an active student context, also shows the student's name.
 * Renders nothing if no user is authenticated.
 */
const RoleContextBadge: React.FC = () => {
  const user = useSelector((state: RootState) => state.auth.user);
  const activeContext = useSelector((state: RootState) => state.context.activeContext);

  if (!user?.role) return null;

  const roleLabel = ROLE_LABELS[user.role] ?? user.role;

  return (
    <div className="role-context-badge">
      <span className={`role-pill role-pill--${user.role.toLowerCase()}`}>{roleLabel}</span>

      {activeContext && user.role === 'PARENT' && (
        <span className="active-student-indicator">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
          </svg>
          <span className="active-student-name">{activeContext.studentName}</span>
        </span>
      )}
    </div>
  );
};

export default RoleContextBadge;
